import styled from 'styled-components'

export const SpinningLoaderWrapper = styled.div<{ $wrapperSize: number }>`
  height: ${({ $wrapperSize }) => $wrapperSize}px;
  width: ${({ $wrapperSize }) => $wrapperSize}px;

  display: flex;
  justify-content: center;
  align-items: center;
`
export const SpinningLoaderSvg = styled.svg<{ $size: number }>`
  height: ${({ $size }) => $size}px;
  width: ${({ $size }) => $size}px;

  @keyframes rotateLoader {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  path {
    transform-origin: center;
    animation: rotateLoader 2s linear infinite;
  }
`

export const WrapperContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`

export const LoaderOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 40px;
  z-index: 1000;
`

export const FixedSizeTextContainer = styled.div<{ $scale?: number }>`
  transform: ${({ $scale }) => ($scale ? `scale(${1 / $scale})` : 'none')};
`

export const LoadingSkeletonContent = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  width: 100%;
  height: 100%;
`

export const LoaderTransparentOverlay = styled.div<{ $backdropFilter: number }>`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(${({ $backdropFilter }) => $backdropFilter}px);
`
